import type { StaleBaseWarning } from '@erp/rpc';
import { useGT } from 'gt-react';
import ConfirmDialog from '@/components/common/ConfirmDialog';
import { TypedNameConfirmField } from '@/components/common/TypedNameConfirmField';
import { useTypedNameConfirm } from '@/components/common/typedNameConfirm';

export function StaleVersionPinDialog({
  warning,
  loading,
  onConfirm,
  onClose,
}: {
  warning: StaleBaseWarning;
  loading: boolean;
  onConfirm: (confirmWorkflowName: string) => Promise<void>;
  onClose: () => void;
}) {
  const gt = useGT();
  const { typed, setTyped, matches } = useTypedNameConfirm(
    warning.workflowName,
  );
  return (
    <ConfirmDialog
      open
      onClose={onClose}
      closeOnConfirm={false}
      onConfirm={() => {
        if (matches) void onConfirm(typed.trim());
      }}
      title={gt('Publish This Version Anyway?', {
        context: 'stale workflow version publish confirmation',
      })}
      message={warning.message}
      confirmText={gt('Publish Anyway', {
        context: 'override a stale workflow version base',
      })}
      cancelText={gt('Cancel', { context: 'cancel stale workflow publish' })}
      disabled={!matches}
      loading={loading}
      dangerous
    >
      <TypedNameConfirmField
        name={warning.workflowName}
        typed={typed}
        onTypedChange={setTyped}
      />
    </ConfirmDialog>
  );
}
